// extracted by mini-css-extract-plugin
export default {"modalForm":"ModalForm_modalForm__fHPMk","modalFormBody":"ModalForm_modalFormBody__JUsj-","modalFormFooter":"ModalForm_modalFormFooter__9IlXC"};